import { useLayoutEffect, useState } from "react"
import { createPortal } from "react-dom"
import { useMap } from "react-leaflet"
import L from "leaflet"

// benchmap portalt children in eine beim Pannen transformierte Pane — HTML-UI muss deshalb zurück in den statischen Karten-Container
export default function MapUiSlot({ children }) {
  const map = useMap()
  const [slot, setSlot] = useState(null)

  useLayoutEffect(() => {
    const el = L.DomUtil.create("div", "map-ui-slot", map.getContainer())
    // contents: kein eigenes Layout, Panels positionieren sich weiter am Container
    el.style.display = "contents"
    // Mausrad über Panels darf die Karte nicht zoomen, egal welcher Wheel-Handler lauscht
    L.DomEvent.disableScrollPropagation(el)
    setSlot(el)
    return () => {
      el.remove()
      setSlot(null)
    }
  }, [map])

  return slot ? createPortal(children, slot) : null
}
